import { Alert, AlertDescription, AlertIcon, Box, Button, FormControl, FormErrorMessage, FormLabel, Input, SimpleGrid, Stack, Text, Textarea } from '@chakra-ui/react';
import { useContactForm } from '../hooks/useContactForm';
const fieldStyles = {
  borderRadius: 'sm',
  borderColor: 'navy.200',
  bg: 'white',
  fontSize: 'sm',
  _hover: {
    borderColor: 'navy.300'
  },
  _focusVisible: {
    borderColor: 'accent.500',
    boxShadow: '0 0 0 1px var(--chakra-colors-accent-500)'
  }
};
export function ContactForm() {
  const {
    values,
    errors,
    status,
    setField,
    submit
  } = useContactForm();
  return <Box as="form" onSubmit={submit} noValidate data-id="element-27" data-mp="luz3hn9mxmip">
      <Stack spacing={6} data-id="element-28" data-mp="lvqmlym1prs3">
        {status === 'success' ? <Alert status="success" variant="subtle" borderRadius="sm" role="status" data-id="element-29" data-mp="h3gymo4hr1sg">
            <AlertIcon data-id="element-30" data-mp="3pj0pjghow84c" />
            <AlertDescription fontSize="sm" data-id="element-31" data-mp="3pihac7jfbxu0">
              Thank you. Your message has been prepared for delivery and our team will review it.
            </AlertDescription>
          </Alert> : null}
        {status === 'error' ? <Alert status="error" variant="subtle" borderRadius="sm" role="alert" data-id="element-32" data-mp="3pjc9r6t375a2">
            <AlertIcon data-id="element-33" data-mp="3uif5u1r3a15w" />
            <AlertDescription fontSize="sm" data-id="element-34" data-mp="35lubowtxbb6">
              Your message could not be sent. Please try again.
            </AlertDescription>
          </Alert> : null}

        <SimpleGrid columns={{
        base: 1,
        md: 2
      }} spacing={6} data-id="element-35" data-mp="83vp3yen69w9">
          <FormControl isRequired isInvalid={Boolean(errors.fullName)} data-id="element-36" data-mp="36n3xvk5kjw5s">
            <FormLabel fontSize="sm" fontWeight={500} color="navy.700" data-id="element-37" data-mp="3bl5jabqgw7kf">
              Full Name
            </FormLabel>
            <Input value={values.fullName} onChange={e => setField('fullName', e.target.value)} autoComplete="name" size="lg" {...fieldStyles} data-id="element-38" data-mp="3gk8opxad0fsx" />
            <FormErrorMessage fontSize="xs" data-id="element-39" data-mp="vtq0ebjbbqee">{errors.fullName}</FormErrorMessage>
          </FormControl>

          <FormControl isRequired isInvalid={Boolean(errors.email)} data-id="element-40" data-mp="zua11p33hc5a">
            <FormLabel fontSize="sm" fontWeight={500} color="navy.700" data-id="element-41" data-mp="2wvftlv1boyez">
              Email Address
            </FormLabel>
            <Input type="email" value={values.email} onChange={e => setField('email', e.target.value)} autoComplete="email" size="lg" {...fieldStyles} data-id="element-42" data-mp="2rww4xmvch8ix" />
            <FormErrorMessage fontSize="xs" data-id="element-43" data-mp="2d88chpgspex7">{errors.email}</FormErrorMessage>
          </FormControl>

          <FormControl data-id="element-44" data-mp="29769cxjrcipy">
            <FormLabel fontSize="sm" fontWeight={500} color="navy.700" data-id="element-45" data-mp="297xvzivdn643">
              Company
            </FormLabel>
            <Input value={values.company} onChange={e => setField('company', e.target.value)} autoComplete="organization" size="lg" {...fieldStyles} data-id="element-46" data-mp="2mzvy39qo81qr" />
          </FormControl>

          <FormControl data-id="element-47" data-mp="1pjgu1pt0caxm">
            <FormLabel fontSize="sm" fontWeight={500} color="navy.700" data-id="element-48" data-mp="1pi5p3mntsx4x">
              Phone
            </FormLabel>
            <Input type="tel" value={values.phone} onChange={e => setField('phone', e.target.value)} autoComplete="tel" size="lg" {...fieldStyles} data-id="element-49" data-mp="4zbqck05kusd" />
          </FormControl>
        </SimpleGrid>

        <FormControl isRequired isInvalid={Boolean(errors.message)} data-id="element-50" data-mp="102rx1u648qh">
          <FormLabel fontSize="sm" fontWeight={500} color="navy.700" data-id="element-51" data-mp="oom2xp4lqzm9">
            Message
          </FormLabel>
          <Textarea value={values.message} onChange={e => setField('message', e.target.value)} rows={6} resize="vertical" {...fieldStyles} data-id="element-52" data-mp="spfpof6b68dk" />
          <FormErrorMessage fontSize="xs" data-id="element-53" data-mp="johijo0kpkqr">{errors.message}</FormErrorMessage>
        </FormControl>

        <Box data-id="element-54" data-mp="2zg5htq327pcq">
          <Button type="submit" variant="solidNavy" size="lg" isLoading={status === 'submitting'} loadingText="Sending" w={{
          base: '100%',
          sm: 'auto'
        }} data-id="element-55" data-mp="2zflvlx6dmesw">
            Send Message
          </Button>
          <Text fontSize="xs" color="navy.400" mt={4} maxW="520px" lineHeight={1.7} data-id="element-56" data-mp="3ey52uoz3sqx8">
            Please use the contact form for general business inquiries and company-related
            communications.
          </Text>
        </Box>
      </Stack>
    </Box>;
}